import { TableView } from 'owa-mail-list-store';
import { getRowKeysFromRowIds } from 'owa-mail-list-store';
import getTableConversationRelation from 'owa-mail-list-store/lib/utils/getTableConversationRelation';
import Message from 'owa-service/lib/contract/Message';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('updateMessageLikers', function updateMessageLikers(
    message: Message,
    tableView: TableView,
    isUnlike: boolean,
    userEmailAddress: string,
    userDisplayName: string
) {
    // Update the message locally so users see changes right away
    if (!isUnlike) {
        if (message.LikeCount) {
            message.LikeCount++;
        } else {
            message.LikeCount = 1;
            message.Likers = [];
        }

        message.Likers.push({
            EmailAddress: userEmailAddress,
            Name: userDisplayName,
            MailboxType: 'Mailbox',
            RoutingType: 'SMTP',
        });
    } else {
        if (message.LikeCount > 1) {
            message.LikeCount--;
            message.Likers = message.Likers.filter(
                emailAdresss => emailAdresss.EmailAddress !== userEmailAddress
            );
        } else {
            // If we end up with 0 LikeCount, then we have to nullify these, which means, no Likes
            message.LikeCount = null;
            message.Likers = null;
        }
    }

    // This updates the TableConversationRelation so the total like count for the conversation is accurate on the
    // local store
    if (
        tableView.tableQuery.listViewType === ReactListViewType.Conversation &&
        message.ConversationId
    ) {
        const rowKeys = getRowKeysFromRowIds([message.ConversationId.Id], tableView);
        for (const rowKey of rowKeys) {
            const tableConversationRelation = getTableConversationRelation(rowKey, tableView.id);
            tableConversationRelation.globalLikeCount += isUnlike ? -1 : 1;
        }
    }
});
